import React, { useState } from 'react'
import { useOrderStore } from 'src/hooks/order';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
//import AuthRepository from 'src/repository/AuthRepository';

const OrderDetailEmailSalesPopup = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const { data, SetStatus } = props;

  const initialState = {
    CC: '',
    subject: '',
    message: ''
  }
  const [formData, SetFormData] = useState(initialState);
  const [validationError, setValidationError] = useState({ CCError: '', subjectError: '', messageError: '' })
  const { avUserInfoData: { currentUser, email } } = System
  const isWebUser = currentUser === Constants.siteUser.WEB

  const [{ }, { }, { export_email_sales }] = useOrderStore();

  const fromEmail = email
  const toEmail = isWebUser ? "OnlineSupportUS@Avnet.com" : data.emailTo
  const emailRegex = Helper.getEmailPattern()

  const OnSend = async () => {
    let error = false
    if (formData.CC.trim() !== '' && !formData.CC.match(emailRegex)) {
      setValidationError(prevState => ({ ...prevState, CCError: "Invalid email. Special characters (-+.'_) must be followed by letters or numbers." }));
      error = true
    }
    if (formData.subject.trim().length > 99) {
      setValidationError(prevState => ({ ...prevState, subjectError: 'Maximum 99 characters allowed' }));
      error = true
    }
    if (formData.message.trim().length > 999) {
      setValidationError(prevState => ({ ...prevState, messageError: 'Maximum 99 characters allowed' }));
      error = true
    }

    if (!error) {
      let res = await export_email_sales({
        // "from": fromEmail,
        // "to": toEmail,
        "cc": formData.CC.replace(/,/g, ";"),
        "subject": formData.subject,
        "message": formData.message
      })

      if (res) {
        System.popup('OrderDetailEmailSendStatusPopup', { isSubmitted: true })
      } else {
        System.popup('OrderDetailEmailSendStatusPopup', { isSubmitted: false })
      }

      SetStatus(false)
    }
  }

  const onChange = (field, value) => {
    SetFormData({ ...formData, [field]: value });
  }
  return (
    <>
      <div className="avnet-modal modal-700">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading pl-5">Email Sales</h3>
          </div>
          {/* Modal body */}
          <div className="modal-body pt-0">
            <div className="clearfix" />

            <div className='mb-3'>
              <div><b>From: </b> {fromEmail}</div>
              <div><b>To: </b> {toEmail}</div>
            </div>

            <div>
              <div className="form-group">
                <label htmlFor='CC'>CC</label>
                <input type="text" name="CC"
                  className="avnet-textBox form-control form-control-sm" placeholder=""
                  onChange={({ target: { value } }) => onChange("CC", value)}
                  value={formData.CC} />
                {/* <Tooltip
                  position={'right center'}
                  opener={() => (
                    
                  )}
                  content={() => (
                    <>
                      Add multiple Email using "," comma separator.
                    </>
                  )}
                /> */}
                <p className="error">{validationError.CCError.trim().length > 0 && validationError.CCError}</p>
              </div>
              <div className="form-group">
                <label htmlFor="Subject">Subject</label>
                <input type="text" name="Subject" maxLength={99}
                  className="avnet-textBox form-control form-control-sm" placeholder="Enter subject"
                  onChange={({ target: { value } }) => onChange("subject", value)} />
                <p className="error">{validationError.subjectError.trim().length > 0 && validationError.subjectError}</p>
              </div>
              <div className="form-group">
                <label htmlFor="Message">Message</label>
                <textarea name="name" rows="8" cols="60" className="avnet-textBox form-control form-control-sm"
                  placeholder="Type your message.." maxLength={999}
                  onChange={({ target: { value } }) => onChange("message", value)}
                  value={formData.message}></textarea>
                <p className="error">{validationError.messageError.trim().length > 0 && validationError.messageError} </p>
              </div>
            </div>
          </div>
          {/* Modal footer */}
          <div className="modal-footer justify-content-center">
            <div className="modal-footer-actions">
              <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                CANCEL
              </button>
              <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                onClick={(() => OnSend())}>
                SEND
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderDetailEmailSalesPopup